export default __webpack_public_path__ + "static/media/HankRnd-Regular.a7511fdb.otf";